const styles = {
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
};

export default styles;
